import { render, staticRenderFns } from "./Discover.vue?vue&type=template&id=669e6db2&scoped=true&"
import script from "./Discover.vue?vue&type=script&lang=js&"
export * from "./Discover.vue?vue&type=script&lang=js&"
import style0 from "./Discover.vue?vue&type=style&index=0&id=669e6db2&prod&scoped=true&lang=css&"
import style1 from "./Discover.vue?vue&type=style&index=1&id=669e6db2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669e6db2",
  null
  
)

export default component.exports